<div class="modal-body text-center">
  <img class="fa-spin" src="/retired-zksync/assets/images/gradient-loading.png" />
  <div class="mt-3">in the progress of completing</div>
</div>
